<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.sharing.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-card class="pa-4 yellow lighten-4" elevation="1" v-if="hashCode !== null">
                        <v-row>
                          <v-col class="col-3">
                            {{ $t("view.sharing.hash_code") }}
                          </v-col>
                          <v-col class="col-9">
                            <b>{{ hashCode }}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                            <v-btn x-small color="primary" elevation="0" outlined v-on:click="urlToClipboard(hashCode)">
                              {{ $t("view.sharing.copy") }}
                            </v-btn>
                            <div class="mt-2" />
                            {{ getTrackingUrl() }}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <v-btn x-small color="primary" elevation="0" outlined
                                   v-on:click="urlToClipboard(getTrackingUrl())">
                              {{ $t("view.sharing.copy") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.sharing.valid_from"
                            rules=""
                          >
                            <DateTimeField
                              v-model="validFrom"
                              :clerable="editable"
                              :text-prefix="$t('view.sharing.valid_from')"
                              :error-messages="errors" />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.sharing.valid_to"
                            rules=""
                          >
                            <DateTimeField
                              v-model="validTo"
                              :clerable="editable"
                              :text-prefix="$t('view.sharing.valid_to')"
                              :error-messages="errors" />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="$t('view.sharing.note')"
                            rules=""
                          >
                            <v-text-field
                              v-model="note"
                              :error-messages="errors"
                              :label="$t('view.sharing.note')"
                              :clearable="editable"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ $t("view.sharing.group.flags") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-checkbox
                        v-model="flagPanic"
                        :value="flagPanic"
                        :label="$t('view.sharing.flag_paninc')"
                        type="checkbox"
                      />

                      <v-checkbox
                        v-model="flagCargoDoor"
                        :value="flagCargoDoor"
                        :label="$t('view.sharing.flag_cargo_door')"
                        type="checkbox"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ $t("view.sharing.group.vehicles") }}
                      <v-spacer />
                      <v-btn v-on:click.stop="selectVehicleDialog"
                             small
                             elevation="0"
                             max-width="100px"
                             class="mr-4"
                             color="primary"
                             :disabled="!editable"
                      >
                        {{ $t("view.sharing.add_vehicle") }}
                      </v-btn>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-list>
                            <v-list-item v-for="item in vehicles" :key="item.vehicleId" link>
                              <v-list-item-title style="max-width: 100px">{{ item.numericPlate }}</v-list-item-title>
                              <v-list-item-title>{{ item.companyName }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.deviceSerialNumber }}</v-list-item-subtitle>
                              <v-list-item-action>
                                <v-tooltip bottom open-delay="500">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon
                                           @click="removeVehicle(item.vehicleId)"
                                           v-on="on"
                                           v-if="editable">
                                      <v-icon color="grey lighten-1">delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("view.sharing.tooltip.remove_vehicle") }}</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <CompanyVehicleSelectionDialog ref="vehicleSelectionDialog" v-on:selected="vehicleSelected" />
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";
import CompanyVehicleSelectionDialog from "@/components/dialogs/CompanyVehicleSelectionDialog.vue";
import DateTimeField from "@/components/fields/DateTimeField.vue";
import { DateTimeValue } from "@/dateTimeValue";

export default {
  name: "SharingView",

  components: { DateTimeField, ResizablePage, CompanyVehicleSelectionDialog },

  data() {
    return {
      editable: this.canWrite("sharing"),
      canLeave: !this.canWrite("sharing"),
      panels: [0, 2],
      newObject: true,

      hashCode: null,
      validFrom: new DateTimeValue(),
      validTo: new DateTimeValue(),
      note: null,

      flagPanic: false,
      flagCargoDoor: false,

      vehicles: [],

      showError: false,
      errorMessage: null,

      record: null
    };
  },

  methods: {
    async store() {
      if (await this.$refs.form_validation.validate()) {

        let object = {
          hashCode: this.hashCode,
          validFrom: this.validFrom.toJson("00:00"),
          validTo: this.validTo.toJson("23:59"),
          note: utils.nullString(this.note),
          flagPanic: this.flagPanic,
          flagCargoDoor: this.flagCargoDoor,
          vehiclesIds: this.vehicles.map(x => x.vehicleId)
        };

        let params = {
          module: "sharing",
          object: object
        };

        if (!utils.isObjectEmpty(this.$store.state.data.record)) {
          params.id = this.record.hashCode;
          object.hashCode = this.record.hashCode;
          object.lastChange = this.record.lastChange;
        }

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/sharings" });
        }
      }
    },

    async remove() {
      let params = {
        module: "sharing",
        id: this.record.hashCode
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/sharings" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/sharings" });
    },

    vehicleSelected(vehicle) {
      if (this.vehicles.filter(x => x.vehicleId === vehicle.vehicleId).length === 0)
        this.vehicles.push(vehicle);
    },

    removeVehicle(vehicleId) {
      this.vehicles = this.vehicles.filter(x => x.vehicleId !== vehicleId);
    },

    selectVehicleDialog() {
      this.$refs.vehicleSelectionDialog.open();
    },

    getTrackingUrl() {
      return process.env.VUE_APP_TRACKING_URL + this.hashCode;
    },

    urlToClipboard(text) {
      utils.toClipboard(text);
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "sharing" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        if (record.hashCode === undefined || record.hashCode === null) {
          this.hashCode = null;
          this.validFrom = new DateTimeValue();
          this.validTo = new DateTimeValue();
          this.flagPanic = false;
          this.flagCargoDoor = false;
          this.note = null;
          this.vehicles = [];

          this.newObject = true;
        } else {
          this.hashCode = record.hashCode;
          this.validFrom = DateTimeValue.fromString(record.validFrom);
          this.validTo = DateTimeValue.fromString(record.validTo);
          this.flagPanic = record.flagPanic;
          this.flagCargoDoor = record.flagCargoDoor;
          this.note = record.note;
          this.vehicles = record.vehicles || [];

          this.newObject = false;
        }

        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {

        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    if (this.$route.params.id === "new")
      this.$store.dispatch("data/fetchRecord", { module: "sharing" });
    else
      this.$store.dispatch("data/fetchRecord", { module: "sharing", id: this.$route.params.id });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style scoped>

</style>